import { satelliteTracker } from '../../../../services/tracking/satellite-tracking-service';
import { PLAYLIST_INLINE_ANALYTICS_EVENTS } from '../../../../utils/analytics';

export const getHandleCardClick = (isDragging, onCardClick) => (isDragging ? () => {} : onCardClick);

export const getHandlePrevClick = (sliderInstance, cardsToSlide) => () => {
  sliderInstance.current?.prev(cardsToSlide);
  satelliteTracker.trackInWeb(PLAYLIST_INLINE_ANALYTICS_EVENTS.CLICK_ON_PREV, {
    gallery_type: PLAYLIST_INLINE_ANALYTICS_EVENTS.GALLERY_TYPE,
  });
};

export const getHandleNextClick = (sliderInstance, cardsToSlide) => () => {
  sliderInstance.current?.next(cardsToSlide);
  satelliteTracker.trackInWeb(PLAYLIST_INLINE_ANALYTICS_EVENTS.CLICK_ON_NEXT, {
    gallery_type: PLAYLIST_INLINE_ANALYTICS_EVENTS.GALLERY_TYPE,
  });
};

export const getHandlePrevKeydown = (handlePrevClick) => (e) => {
  if (e?.key === 'Enter' || e?.key === ' ') {
    e?.preventDefault();
    handlePrevClick();
  }
};

export const getHandleNextKeydown = (handleNextClick) => (e) => {
  if (e?.key === 'Enter' || e?.key === ' ') {
    e?.preventDefault();
    handleNextClick();
  }
};
